/**
 * Retrieves the enum options for a given value of type 'css-string'.
 *
 * @param value The value of type 'css-string'.
 * @returns An object containing the selected option and all available options, or undefined if no options are found.
 */ export const getEnumOptions = (value, baseType)=>{
    return undefined;
// const cssEnumHint = value?.cssEnumHint || baseType?.cssEnumHint
// if (cssEnumHint) {
//   console.log(`getEnumOptions - cssEnumHint`, cssEnumHint, enumEditingConfigMap)
//   let options: Record<string, any> | undefined =
//     enumEditingConfigMap[cssEnumHint as keyof typeof enumEditingConfigMap]?.options
//   if (!options && cssEnumHint in cssEnumTypeMap) {
//     options = (cssEnumTypeMap[cssEnumHint as keyof typeof cssEnumTypeMap] || []).reduce(
//       (acc, x) => ({
//         ...acc,
//         [x]: {
//           value: x,
//           label: x,
//         },
//       }),
//       {} as Record<string, any>
//     )
//   }
//   if (options) {
//     const option = ((options || {}) as any)[value?.value as any]
//     // Now we may have an option to use
//     if (option || !value?.value) {
//       return {
//         option,
//         options,
//       }
//     }
//   }
// }
// return undefined
};
